/** VN-09 / VD-44: jpg, png or pdf up to 10 MB. */
export const ATTACHMENT_EXTENSIONS = [".jpg", ".jpeg", ".png", ".pdf"];
export const ATTACHMENT_FORMATS = ["jpg", "jpeg", "png", "pdf"];
export const ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
/** VD-44 for the decision (Approve / Reject) panels: at most 10 files. */
export const DECISION_MAX_ATTACHMENTS = 10;
/** Files per nomination are not capped by the API; the upload control still needs a number. */
export const ATTACHMENT_MAX_FILES = 100;
